import { PasswordResetStepGuard } from 'presentation/app/contexts/PasswordResetStepGuard';
import React from 'react';

import { VerifyCodePage } from './index';

export function ProtectedVerifyCodePage() {
  return (
    <PasswordResetStepGuard step="code">
      <VerifyCodePage />
    </PasswordResetStepGuard>
  );
}
